module.exports = __webpack_public_path__ + "img/register.85b37874.jpg";